
import { Component, Prop, Watch, Vue } from 'vue-property-decorator'
import { ConfigModule } from '@/store/modules/config'
import { CONFIGAPI } from '@/api/config'
import { getuserCurrentApp } from '@/utils/cookies'

@Component({
  name: 'editDialog',
  components: {}
})
export default class extends Vue {
  @Prop({ default: 'edit' }) private type!: string
  @Prop({ default: () => { return {} } }) private node!: any
  private isDisableSubmit: boolean = false
  private formData = {
    id: 0,
    name: ''
  }
  private rules = {
    name: [
      { required: true, message: '请输入笔记本型号的名称', trigger: 'blur' }
    ]
  }

  get userCurrentApp() {
    return getuserCurrentApp()
  }

  get dialogVisible() {
    return ConfigModule.computerAddDialog
  }

  @Watch('dialogVisible')
  private initForm() {
    if (this.dialogVisible) { // 打开弹框
      if (this.type === 'add' && this.node) {
        this.formData = {
          id: 0,
          name: ''
        }
      } else if (this.type === 'edit') {
        this.formData = Object.assign({}, this.node)
      }
    }
  }

  // 提交按钮触发
  private handleSubmit(formName: string) {
    (this.$refs[formName] as any).validate((valid: any) => {
      if (valid) {
        this.isDisableSubmit = true
        if (this.type === 'add') {
          this.addRequest()
        } else {
          this.editRequest()
        }
      } else {
        return false
      }
    })
  }

  // 新建保存
  private addRequest() {
    CONFIGAPI.addComputerType({
      name: this.formData.name
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'computerAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 编辑保存
  private editRequest() {
    CONFIGAPI.editComputerType({
      name: this.formData.name,
      id: this.formData.id
    }, {
      app_id: this.userCurrentApp
    }).then((res) => {
      if (res.stat === 1) {
        this.$message.success(res.data)
        ConfigModule.ToggleDialogStatus({
          name: 'computerAddDialog',
          value: false
        })
        this.$emit('handleSuccess')
      }
      this.isDisableSubmit = false
    }).catch((error) => {
      console.log('发生错误！', error)
      this.isDisableSubmit = false
    })
  }

  // 关闭弹框
  private handleClose() {
    ConfigModule.ToggleDialogStatus({
      name: 'computerAddDialog',
      value: false
    })
  }
}
